import { SCHEDULE_SESSION_DISPLAY_TYPE_ROUND } from "../constants";

/**
 * Returns true if user is expected to be present (either is mandatory or it was selected by the user)
 * @param {object} session Session to check
 * @returns boolean
 */
export function isSessionAttendanceRequired(session) {
    return session.display_type != SCHEDULE_SESSION_DISPLAY_TYPE_ROUND && (!session.is_selectable || session.is_selected);
}
